import { useEffect, useState } from 'react';
import BBITable from '../../helpers/bBITable/BBITable';
import React from 'react';
import Get from '../../api/internal/Get';
import FilterData from '../../helpers/filter/FilterData';
import View from '../../helpers/slab/View';
import ViewTrailer from '../../features/views/assets/trailer/Trailer';
import { useOutletContext } from 'react-router-dom';
import { PageLoadingSpinner } from '../../helpers/loadingSpinner/LoadingSpinner';
import DateOnlyFormatter from '../../helpers/inputs/DateOnlyFormatter';
import Header from '../../layouts/Header';
import DownloadCsvButton from '../../helpers/buttons/DownloadCsvButton';

function TrailerBoard({ toggleBoardRefresh }) {
  const [trailers, setTrailers] = useState<TrailerBoard[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const filterValue = useOutletContext();

  useEffect(() => {
    GetTrailerBoard();
  }, [toggleBoardRefresh]);

  function GetTrailerBoard() {
    setIsLoading(true);
    Get(`/Asset/GetTrailerBoard`)
      .then(response => {
        if (response) {
          setTrailers(response.data);
          setIsLoading(false);
        }
      })
      .finally(() => setIsLoading(false));
  }

  if (isLoading) {
    return <PageLoadingSpinner />;
  }

  function FormatTrailerBoard(trailers) {
    return trailers.map(trailer => ({
      ...trailer,
      weeklyCost:
        trailer.weeklyCost?.toLocaleString(undefined, {
          style: 'currency',
          currency: 'USD',
        }) ?? null,
      registrationExpiration: DateOnlyFormatter(trailer.registrationExpiration),
      federalInspectionExpiration: DateOnlyFormatter(trailer.federalInspectionExpiration),
    }));
  }

  const columnConfig = [
    {
      key: '1',
      attribute: 'trailerName',
      attributeprimaryhidden: 'assetId',
      header: 'Trailer Unit #',
      onClick: e =>
        View(
          <ViewTrailer
            trailerName={e.target.innerText}
            assetId={e.target.dataset.attributeprimaryhidden}
          />,
        ),
    },
    {
      key: '2',
      attribute: 'vin',
      header: 'VIN',
    },
    {
      key: '3',
      attribute: 'make',
      header: 'Make',
    },
    {
      key: '4',
      attribute: 'model',
      header: 'Model',
    },
    {
      key: '5',
      attribute: 'year',
      header: 'Year',
    },
    {
      key: '6',
      attribute: 'licensePlateNumber',
      header: 'Plate',
    },
    {
      key: '7',
      attribute: 'licensePlateState',
      header: 'Plate State',
    },
    {
      key: '8',
      attribute: 'ownership',
      header: 'Ownership',
    },
    {
      key: '9',
      attribute: 'trailerType',
      header: 'Type',
    },
    {
      key: '10',
      attribute: 'sellerOrLessorName',
      header: 'Seller / Lessor',
    },
    {
      key: '11',
      attribute: 'inTransitHeat',
      header: 'In Transit Heat',
    },
       {
      key: '12',
      attribute: 'driverName',
      header: 'Driver',
    },
    {
      key: '13',
      attribute: 'weeklyCost',
      header: 'Weekly Cost',
      dataType: 'currency',
    },
    {
      key: '14',
      attribute: 'registrationExpiration',
      header: 'Registration Exp.',
    },
    {
      key: '15',
      attribute: 'federalInspectionExpiration',
      header: 'Federal Inspection Exp.',
    },
  ];

  const tableData = FilterData(trailers, filterValue);

  const csvData = FormatTrailerBoard(tableData);

  return (
    <>
      <Header>
        <div>
          <DownloadCsvButton
            data={csvData}
            columnConfig={columnConfig}
            fileName={`Trailers_${new Date().toLocaleDateString()}.csv`}
          />
        </div>
      </Header>
      <BBITable data={csvData} columns={columnConfig} />
    </>
  );
}

export default TrailerBoard;
